export const isMediumOrLargeScreen = window.innerWidth >= 712;
export const peopleCount = ["<20", "20-39", "40-59", "60-79", "80-99", "100+"];
export const mealTimings = {
  breakfast: ["8:00 am", "9:00 am", "10:00 am"],
  lunch: ["11:30 am", "12:00 pm", "12:30 pm"],
  dinner: ["4:00 pm", "5:00 pm", "6:00 pm"],
};
export const weekDays = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];
export const canadianProvinces = [
  "Alberta",
  "Manitoba",
  "New Brunswick",
  "Nova Scotia",
  "British Columbia",
  "Ontario",
  "Newfoundland and Labrador",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
  "Yukon",
  "Nunavut",
  "Northwest Territories",
];
export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const isSmallScreen = window.innerWidth <= 711;
export const monthsArray = [
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "July" },
  { value: "8", label: "August" },
  { value: "9", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];
export const weekDaysArray = ["S", "M", "T", "W", "T", "F", "S"];
export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const dateRange = {
  minSelectableDate: (() => {
    const minDate = new Date();
    minDate.setDate(minDate.getDate() + 7);
    return minDate;
  })(),
  maxSelectableDate: (() => {
    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 3, 0);
    return maxDate;
  })(),
};
export const isMediumOrSmallScreen = window.innerWidth <= 1024;
